<template>
    <div id="voucher-select" class="voucher-select" @click="open()">
        <ul class="list list-select">
            <li class="list-item">
                <div class="voucher arr-row ellipsis">
                    <span id="voucherSelect-span-name" v-if="list.length>0">{{list[selected].cardType | cardType}}/{{list[selected].holderName}}/{{list[selected].cardNo | dotted}}</span>
                    <span id="voucherSelect-span-none" v-else>无</span>
                </div>
            </li>
        </ul>
        <popup class="popup-select mybgcolor" v-model="isActive" :title="'选择就诊凭证'">
            <voucher-item-small :id="'voucherItem-component-' + voucher.cardNo" v-for="(voucher, index) in list" :key="index" :voucher="voucher" :index="index" :class="(selected == index) ? 'selected' : 'disabled'" @selected="selectVoucher"></voucher-item-small>
        </popup>
    </div>
</template>
<script>
    import VoucherItemSmall from '../modules/voucher/VoucherItemSmall'
    export default{
        components: {
            VoucherItemSmall
        },
        props: {
            //由于页面刷新同步问题不封装网络请求
            list: {
                type: Array
            },
        },
        data() {
            return {
                isActive: false,
                selected: 0
            }
        },
        methods: {
            open() {
                this.isActive = !!this.list.length;
            },
            selectVoucher(voucher, index) {
                if (this.selected !== index) {
                    this.selected = index;
                    this.$emit('selected', voucher);
                }
                this.isActive = false;
            }
        },
        watch: {
            list() {
                this.selected = 0;
            }
        }
    }
</script>
<style lang="scss">
    @import './static/sass/_variable.scss';
    .voucher-select {
        .list {
            .list-item {
                border: none;
            }
        }
    }
    .mybgcolor {
        background-color: $common-bg-color;
    }
</style>


// WEBPACK FOOTER //
// VoucherSelect.vue?4cdb2278